export const PAID = 0;
export const UNPAID = 1;
export const OVERDUE = 2;
export const PAST_DUE = 3;
export const PROCESSING = 4;
export const ANALYZING = 5;
export const CANCELLED = 6;

export const invoiceStatus = [
    {
        status: PAID,
        class: 'mr-2 text-success',
        icon: 'mdi mdi-check-all',
        name: 'financial.invoices.status.paid',
    },
    {
        status: UNPAID,
        class: 'mr-2 text-blue',
        icon: 'mdi mdi-calendar-clock',
        name: 'financial.invoices.status.open',
    },
    {
        status: OVERDUE,
        class: 'mr-2 text-orange',
        icon: 'mdi mdi-alert',
        name: 'financial.invoices.status.overdue',
    },
    {
        status: PAST_DUE,
        class: 'mr-2 text-red',
        icon: 'mdi mdi-alert',
        name: 'financial.invoices.status.past_due',
    },
    {
        status: PROCESSING,
        class: 'mr-2 text-yellow',
        icon: 'mdi mdi-clock-outline',
        name: 'financial.invoices.status.pending',
    },
    {
        status: ANALYZING,
        class: 'mr-2 text-yellow',
        icon: 'mdi mdi-clock-outline',
        name: 'financial.invoices.status.analyzing',
    },
    {
        status: CANCELLED,
        class: 'mr-2 text-gray',
        icon: 'mdi mdi-close-circle',
        name: 'financial.invoices.status.canceled',
    },
];
/**
 * This mixin can be used to invoice
 */
export default {
    methods: {
        statusInvoice(value) {
            const item = invoiceStatus.find(({ status }) => (
                status === value
            ));
            return item ? {
                ...item,
                name: this.$t(item.name),
            } : null;
        },
    },
};
